import logo from './logo.png';
import './App.css';

import React, { useState, useEffect } from 'react';
import axios from 'axios';

const App = () => {
  const [search, setSearch] = useState('');
  const [cocktails, setCocktails] = useState([]);
  const [query, setQuery] = useState('');

  useEffect(() => {
    axios
      .get(
        `https://www.thecocktaildb.com/api/json/v1/1/search.php?s=${query}`
      )
      .then((res) => {
        setCocktails(res.data.drinks);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [query]);

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setQuery(search);
    setSearch('');
  };

  return (
    <div>
      <nav className="navbar">
      <div className="nav-center">
          <img src={logo} alt="CocktailDB" className="logo" />
        <h2>Search your desired drink</h2>
      </div>
    </nav>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={search}
          onChange={handleChange}
        />
        <button type="submit">Search</button>
      </form>
      <div className='cocktails'>
      {cocktails.map((cocktail) => (
        <div className='drinks' key={cocktail.idDrink}>
          <h3>{cocktail.strDrink}</h3>
          <img
            src={cocktail.strDrinkThumb}
            alt={cocktail.strDrink}
          />
          <p>{cocktail.strInstructions}</p>
          <ul>
            { cocktail.strIngredient1 && <li>{cocktail.strIngredient1} - {cocktail.strMeasure1}</li> }
            { cocktail.strIngredient2 && <li>{cocktail.strIngredient2} - {cocktail.strMeasure2}</li> }
            { cocktail.strIngredient3 && <li>{cocktail.strIngredient3} - {cocktail.strMeasure3}</li> }
            { cocktail.strIngredient4 && <li>{cocktail.strIngredient4} - {cocktail.strMeasure4}</li> }
            { cocktail.strIngredient5 && <li>{cocktail.strIngredient5} - {cocktail.strMeasure5}</li> }
            { cocktail.strIngredient6 && <li>{cocktail.strIngredient6} - {cocktail.strMeasure6}</li> }
            { cocktail.strIngredient7 && <li>{cocktail.strIngredient7} - {cocktail.strMeasure7}</li> }
            { cocktail.strIngredient8 && <li>{cocktail.strIngredient8} - {cocktail.strMeasure8}</li> }
            { cocktail.strIngredient9 && <li>{cocktail.strIngredient9} - {cocktail.strMeasure9}</li> }
            { cocktail.strIngredient10 && <li>{cocktail.strIngredient10} - {cocktail.strMeasure10}</li> }
            { cocktail.strIngredient11 && <li>{cocktail.strIngredient11} - {cocktail.strMeasure11}</li> }
            { cocktail.strIngredient12 && <li>{cocktail.strIngredient12} - {cocktail.strMeasure12}</li> }
            { cocktail.strIngredient13 && <li>{cocktail.strIngredient13} - {cocktail.strMeasure13}</li> }
            { cocktail.strIngredient14 && <li>{cocktail.strIngredient14} - {cocktail.strMeasure14}</li> }
          </ul>
        </div>
      ))}
      </div>
    </div>
  );
};

export default App;